<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍卖场次">{{info.title}}</a-form-item>
      <a-form-item label="开始预览">{{info.preview}}</a-form-item>
      <a-form-item label="开始时间">{{info.start_at}}</a-form-item>
      <a-form-item label="结束时间">{{info.end_at}}</a-form-item>
      <a-form-item label="备注信息">{{info.desc}}</a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="update">编辑</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec {
  margin: 15px;
}
img {
  max-width: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      info: {},
    };
  },
  async created() {
    const id = this.$route.query.id;
    const r = await this.$axios.get("/tuanpai/getInfo?id=" + id);
    if (r.status == 1) {
      this.info = r.info;
    }
  },
  methods: {
    update() {
      this.$router.push(`/tuanpai/update?id=${this.info.id}`);
    },
  },
};
</script>